var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.isCollapse
        ? _c(
            "el-row",
            { staticStyle: { padding: "0 0" } },
            [
              _c("div", { staticClass: "tilte" }, [
                _c("img", {
                  staticClass: "logoimg",
                  attrs: { alt: "", src: require("@/assets/nav_logo.png") }
                })
              ]),
              _c(
                "el-scrollbar",
                { staticStyle: { height: "calc(100vh - 70px)" } },
                [
                  _c(
                    "transition",
                    {
                      attrs: {
                        duration: { enter: 800, leave: 100 },
                        mode: "out-in",
                        name: "el-fade-in-linear"
                      }
                    },
                    [
                      _c(
                        "el-menu",
                        {
                          staticClass: "el-menu-vertical",
                          attrs: {
                            collapse: true,
                            "default-active": _vm.active,
                            "active-text-color": "#fff",
                            "text-color": "rgb(191, 203, 217)",
                            "background-color": "#191a23",
                            "unique-opened": ""
                          },
                          on: { select: _vm.selectMenuItem2 }
                        },
                        [
                          _vm._l(_vm.asyncRouters[0].children, function(item) {
                            return [
                              !item.hidden
                                ? _c("aside-component", {
                                    key: item.name,
                                    attrs: { "router-info": item }
                                  })
                                : _vm._e()
                            ]
                          })
                        ],
                        2
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        : _c(
            "el-row",
            { staticStyle: { padding: "0 0" } },
            [
              _c(
                "el-col",
                { staticClass: "side-menu1", attrs: { span: 10 } },
                [
                  _c("div", { staticClass: "tilte" }, [
                    _c("h2", { staticClass: "tit-text" }, [
                      _vm._v(_vm._s(_vm.$BAIRUN_ADMIN.appName))
                    ])
                  ]),
                  _c(
                    "el-scrollbar",
                    { staticStyle: { height: "calc(100vh - 70px)" } },
                    [
                      _c(
                        "transition",
                        {
                          attrs: {
                            duration: { enter: 800, leave: 100 },
                            mode: "out-in",
                            name: "el-fade-in-linear"
                          }
                        },
                        [
                          _c(
                            "el-menu",
                            {
                              staticClass: "el-menu-vertical",
                              attrs: {
                                "default-active": _vm.menuActive1,
                                "active-text-color": "#fff",
                                "text-color": "#fff",
                                "background-color": "#191a23",
                                "unique-opened": ""
                              },
                              on: { select: _vm.selectMenuItem1 }
                            },
                            [
                              _vm._l(_vm.asyncRouters[0].children, function(
                                item
                              ) {
                                return [
                                  !item.hidden
                                    ? _c("MenuItem", {
                                        key: item.name,
                                        tag: "component",
                                        attrs: { "router-info": item }
                                      })
                                    : _vm._e()
                                ]
                              })
                            ],
                            2
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-col",
                { staticClass: "side-menu2", attrs: { span: 14 } },
                [
                  _c("div", { staticClass: "tilte" }, [
                    _c("h2", { staticClass: "tit-text" }, [
                      _vm._v(_vm._s(_vm.subMenuData2.title))
                    ])
                  ]),
                  _c(
                    "el-scrollbar",
                    {
                      staticStyle: {
                        height: "calc(100vh - 80px)",
                        "padding-bottom": "30px"
                      }
                    },
                    [
                      _c(
                        "transition",
                        {
                          attrs: {
                            duration: { enter: 800, leave: 100 },
                            mode: "out-in",
                            name: "el-fade-in-linear"
                          }
                        },
                        [
                          _c(
                            "el-menu",
                            {
                              staticClass: "el-menu-vertical",
                              attrs: {
                                "default-active": _vm.menuActive2,
                                "active-text-color": "#1e1e28",
                                "text-color": "#1e1e28",
                                "background-color": "#ffffff",
                                "default-openeds":
                                  _vm.subMenuData2.defaultOpeneds
                              },
                              on: { select: _vm.selectMenuItem2 }
                            },
                            [
                              _vm._l(_vm.subMenuData2.children, function(item) {
                                return [
                                  !item.hidden
                                    ? _c("aside-component", {
                                        key: item.name,
                                        attrs: {
                                          "router-info": item,
                                          showIcon: false
                                        }
                                      })
                                    : _vm._e()
                                ]
                              })
                            ],
                            2
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }